const DAY_MS = 86_400_000

/** Whole days until `validUntilMs` (rounded up, never negative); null when unset. */
export function daysUntil(validUntilMs: number, now: number): number | null {
  if (!Number.isFinite(validUntilMs) || validUntilMs <= 0) return null
  return Math.max(0, Math.ceil((validUntilMs - now) / DAY_MS))
}
